import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    // Check if we need to reopen drawer after free gift was added
    this.#checkFreeGiftFlag();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /**
   * Checks if free gift was added and drawer should be reopened after page reload
   */
  #checkFreeGiftFlag() {
    const freeGiftAdded = sessionStorage.getItem('freeGiftAdded');

    if (freeGiftAdded === 'true') {
      // Remove flag immediately to prevent multiple openings
      sessionStorage.removeItem('freeGiftAdded');
      console.log('[CartDrawer] Free gift was added, reopening drawer');

      // Open drawer with small delay to ensure proper initialization
      setTimeout(() => {
        this.showDialog();
      }, 100);
    }
  }

  /**
   * Handles cart add events
   * @param {CartAddEvent} event - The cart add event
   */
  #handleCartAdd = (event) => {
    // Always open cart drawer when adding from product page
    const isFromProductPage = event.detail?.data?.source === 'product-form-component';

    if (this.hasAttribute('auto-open') || isFromProductPage) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
